import React, { useState } from 'react';

import { StyledCoverTile } from './CoverTile.styles';
import { TCoverTileProps } from './CoverTile.types';

const matchesAccept = (file: File, accept?: string): boolean => {
  if (!accept) {
    return true;
  }
  return accept.split(',').some((entry) => {
    const pattern = entry.trim();
    if (pattern.endsWith('/*')) {
      return file.type.startsWith(pattern.slice(0, -1));
    }
    return file.type === pattern;
  });
};

const CoverTile = ({
  image,
  height = 120,
  accept,
  onDropFile,
  children,
  ...props
}: TCoverTileProps) => {
  const [dragging, setDragging] = useState(false);

  const dropProps = onDropFile
    ? {
        onDragOver: (event: React.DragEvent<HTMLElement>) => {
          event.preventDefault();
          setDragging(true);
        },
        onDragLeave: () => setDragging(false),
        onDrop: (event: React.DragEvent<HTMLElement>) => {
          event.preventDefault();
          setDragging(false);
          const file = event.dataTransfer.files?.[0];
          if (file && matchesAccept(file, accept)) {
            onDropFile(file);
          }
        },
      }
    : {};

  return (
    <StyledCoverTile $image={image} $height={height} $dragging={dragging} {...dropProps} {...props}>
      {children}
    </StyledCoverTile>
  );
};

export default CoverTile;
